import type { ElementType } from 'react';
import { Accordion } from './components/Accordion';
import { AccordionItem } from './components/AccordionItem';
import { AnchorLink } from './components/AnchorLink';
import { AnchorLinkTarget } from './components/AnchorLinkTarget';
import { Blockquote } from './components/Blockquote';
import { CalculatedFieldsForm } from './components/CalculatedFieldsForm';
import { Column } from './components/Columns/Column';
import { Columns } from './components/Columns/Columns';
import { Container } from './components/Container';
import { ContentHeading } from './components/ContentHeading';
import { ContentImage } from './components/ContentImage';
import { ContentSection } from './components/ContentSection';
import { CreditCardsAccordion } from './components/CreditCardsAccordion/CreditCardsAccordion';
import { CreditCardsAccordionItem } from './components/CreditCardsAccordion/CreditCardsAccordionItem';
import { CreditCardsAskOurExperts } from './components/CreditCardsAskOurExperts';
import { CreditCardsCardList } from './components/CreditCardsCardList/CreditCardsCardList';
import { CreditCardsCardListItem } from './components/CreditCardsCardList/CreditCardsCardListItem';
import { CreditCardsIconItem } from './components/CreditCardsIconItem';
import { CreditCardsLeftNav } from './components/CreditCardsLeftNav';
import { CreditCardsOfferRatesAndFeesLink } from './components/CreditCardsOfferRatesAndFeesLink';
import { CreditCardsSlideshow } from './components/CreditCardsSlideshow';
import { CreditCardsTableOfContents } from './components/CreditCardsTableOfContents';
import { CreditCardsTableOfContentsSection } from './components/CreditCardsTableOfContentsSection';
import { Document } from './components/Document';
import { EnhancedContentHeading } from './components/EnhancedContentHeading';
import { ExpandCard } from './components/ExpandCard';
import { Infogram } from './components/Infogram';
import { Li } from './components/Li';
import { List } from './components/List';
import { MarketplaceField } from './components/MarketplaceField';
import { MegaphoneFm } from './components/MegaphoneFm';
import { NerdTip } from './components/NerdTip';
import { NWVerifiedContainer } from './components/NWVerifiedContainer';
import { ShowMoreToggle } from './components/ShowMoreToggle';
import { Spacer } from './components/Spacer';
import { Type } from './components/Type';
import { Video } from './components/Video';
import { Well } from './components/Well';
import { WPBlock } from './components/WPBlock';
import { WPEmbed } from './components/WPEmbed';
import { WPTable } from './components/WPTable';

export const STRUCTURED_CONTENT_COMPONENTS_BASE: Record<string, ElementType> = {
  Accordion,
  AccordionItem,
  AnchorLink,
  AnchorLinkTarget,
  CalculatedFieldsForm,
  CreditCardsAccordion,
  CreditCardsAccordionItem,
  CreditCardsAskOurExperts,
  CreditCardsCardList,
  CreditCardsCardListItem,
  CreditCardsIconItem,
  CreditCardsOfferRatesAndFeesLink,
  CreditCardsSlideshow,
  CreditCardsTableOfContents,
  CreditCardsTableOfContentsSection,
  Container,
  ExpandCard,
  ContentQuote: Blockquote,
  ContentHeading,
  ContentImage,
  ContentSection,
  Column,
  Columns,
  Document,
  EnhancedContentHeading,
  Infogram,
  CreditCardsLeftNav,
  Li,
  List,
  MarketplaceField,
  MegaphoneFm,
  NerdTip,
  NWVerifiedContainer,
  ShowMoreToggle,
  Spacer,
  Type,
  Video,
  Well,
  WPBlock,
  WPTable,
  WPEmbed,
};

export const STRUCTURED_CONTENT_COMPONENTS_LEARN_CONTENT_OVERRIDES: Record<string, ElementType> = {
  ContentHeading: EnhancedContentHeading,
  ContentQuote: Blockquote,
};
